export default {
  title: {
    id: 'bo_sellers-listing-search-product-no-search-title',
    defaultMessage: 'What will you sell today?',
  },
}
